import * as types from 'models/actionTypes'

const initialState = {
    hasOutage: false,
}

const support = (state = initialState, action) => {
    switch (action.type) {
        case types.RECEIVE_STATUS:
            return {
                ...state,
                hasOutage: action.status.outage,
            }
        default:
            return state
    }
}

export default support
